import { render, staticRenderFns } from "./CopyRestaurant.vue?vue&type=template&id=6ec84571"
import script from "./CopyRestaurant.vue?vue&type=script&lang=ts"
export * from "./CopyRestaurant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports